module.exports = __webpack_public_path__ + "img/case_chewpy_portrait.8e952630.jpg";